import React, { Component } from 'react';
import Show from '../components/settings/Procesos/Show'
import WebpackerReact from 'webpacker-react';

class ProcesoShow extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();

    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    loadData = () => {
        fetch(`/settings/get_proceso_scores/${this.props.proceso.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Show
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    proceso={this.props.proceso}
                    users={this.props.users}
                    isLoaded={this.state.isLoaded}
                    califications_date={[]}
                    califications_value={[]}
                    usuario={this.props.usuario} 
             
                />
            </React.Fragment>
        );
    }
}


export default ProcesoShow;
WebpackerReact.setup({ ProcesoShow });
